import { Navigate } from "react-router-dom";
import { useContext } from "react";
import PropTypes from "prop-types"; // Import PropTypes
import AuthContext from "../context/auth_context";

const PrivateRoute = ({ children, ...rest }) => {
  let { user } = useContext(AuthContext);

  return !user ? <Navigate to="/sign-in" /> : children;
};

// Define propTypes to validate props
PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PrivateRoute;
